import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40a04d8d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ImportProgressDialog-checkBox" }
const _hoisted_2 = { class: "dropdown" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "link link-secondary text-decoration-none dropdown-toggle",
  href: "#",
  role: "button",
  id: "dropdownMenuLink",
  "data-bs-toggle": "dropdown",
  "data-bs-auto-close": "outside",
  "aria-expanded": "false"
}, " Типы сообщений ", -1))
const _hoisted_4 = {
  class: "dropdown-menu",
  "aria-labelledby": "dropdownMenu"
}
const _hoisted_5 = { class: "ImportProgressDialog-messageList" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  innerHTML: '  '
}
const _hoisted_8 = ["onClick", "innerHTML"]
const _hoisted_9 = ["onClick", "innerHTML"]
const _hoisted_10 = {
  key: 3,
  class: "ImportProgressDialog-messageDetails"
}
const _hoisted_11 = { class: "d-inline-block ImportProgressDialog-progressBarWrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxCheckBox = _resolveComponent("DxCheckBox")!
  const _component_DxScrollView = _resolveComponent("DxScrollView")!
  const _component_DxProgressBar = _resolveComponent("DxProgressBar")!
  const _component_DxToolbarItem = _resolveComponent("DxToolbarItem")!
  const _component_DxPopup = _resolveComponent("DxPopup")!

  return (_openBlock(), _createBlock(_component_DxPopup, {
    visible: _ctx.popupVisible,
    "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.popupVisible) = $event)),
    "drag-enabled": true,
    "close-on-outside-click": false,
    "show-title": true,
    showCloseButton: false,
    width: 680,
    height: 450,
    shading: true,
    resizeEnabled: true,
    title: _ctx.isImport ? 'Импорт данных...' : 'Экспорт данных...',
    onHidden: _ctx.onHidden,
    onShown: _ctx.onShown
  }, {
    default: _withCtx(() => [
      _createVNode(_component_DxScrollView, {
        width: "100%",
        height: "100%",
        style: {"position":"relative"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DxLoadPanel, {
            position: _ctx.loadingPanelPosition,
            visible: _ctx.stopping,
            "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.stopping) = $event)),
            "show-indicator": true,
            "show-pane": true,
            shading: false,
            "close-on-outside-click": false
          }, null, 8, ["position", "visible"]),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("ul", _hoisted_4, [
                _createElementVNode("li", null, [
                  _createVNode(_component_DxCheckBox, {
                    class: "ImportProgressDialog-checkbox",
                    value: _ctx.isMessage,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isMessage) = $event)),
                    text: "Сообщения"
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_DxCheckBox, {
                    class: "ImportProgressDialog-checkbox",
                    value: _ctx.isWarning,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isWarning) = $event)),
                    text: "Предупреждения"
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_DxCheckBox, {
                    class: "ImportProgressDialog-checkbox",
                    value: _ctx.isError,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isError) = $event)),
                    text: "Ошибки"
                  }, null, 8, ["value"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", {
            onMouseover: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isScrollUpdating = false)),
            onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isScrollUpdating = true)),
            class: "mb-4 ImportProgressDialog-scrollView"
          }, [
            _createVNode(_component_DxScrollView, { ref: "scrollView" }, {
              default: _withCtx(() => [
                _createElementVNode("ul", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.viewMessages, (m, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      tabindex: "0",
                      key: index
                    }, [
                      (_ctx.getVisibility(m.Type))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("span", {
                              style: _normalizeStyle({ color: _ctx.getMessageColor(m.Type) })
                            }, _toDisplayString(m.Message), 5),
                            (m.Details)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_7))
                              : _createCommentVNode("", true),
                            (m.Details && !m.detailsVisible)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  class: "ImportProgressDialog-link",
                                  onClick: ($event: any) => (_ctx.onShowDetailsClick(m)),
                                  innerHTML: 'Подробно...'
                                }, null, 8, _hoisted_8))
                              : _createCommentVNode("", true),
                            (m.Details && m.detailsVisible)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 2,
                                  class: "ImportProgressDialog-link",
                                  onClick: ($event: any) => (_ctx.onHideDetailsClick(m)),
                                  innerHTML: 'Скрыть...'
                                }, null, 8, _hoisted_9))
                              : _createCommentVNode("", true),
                            (m.Details && m.detailsVisible)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                                  _createElementVNode("span", null, _toDisplayString(m.Details), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }, 512)
          ], 32),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_DxProgressBar, {
              class: "ImportProgressDialog-progressBar",
              id: "progress-bar-status",
              min: 0,
              max: 100,
              "status-format": _ctx.progressStatusFormat,
              value: _ctx.progressValue,
              width: "100%"
            }, null, 8, ["status-format", "value"])
          ])
        ]),
        _: 1
      }),
      (_ctx.downloadButtonVisible)
        ? (_openBlock(), _createBlock(_component_DxToolbarItem, {
            key: 0,
            options: _ctx.downloadButtonOptions,
            widget: "dxButton",
            location: "after",
            toolbar: "bottom"
          }, null, 8, ["options"]))
        : _createCommentVNode("", true),
      (_ctx.closeButtonVisible)
        ? (_openBlock(), _createBlock(_component_DxToolbarItem, {
            key: 1,
            options: _ctx.closeButtonOptions,
            widget: "dxButton",
            location: "after",
            toolbar: "bottom"
          }, null, 8, ["options"]))
        : (_openBlock(), _createBlock(_component_DxToolbarItem, {
            key: 2,
            options: _ctx.stopButtonOptions,
            widget: "dxButton",
            location: "after",
            toolbar: "bottom",
            disabled: _ctx.stopping
          }, null, 8, ["options", "disabled"]))
    ]),
    _: 1
  }, 8, ["visible", "title", "onHidden", "onShown"]))
}